import { CustomerLocationDto } from "../../back-office/shared/models/customer/customer-location.model";
import { CountryDTO } from "../utilities/countries.models";
export class LocationBaseDTO {
  id?: number;
  address1?: string;
  address2?: string;
  city?: string;
  province?: string;
  country?: CountryDTO;
  externalId?: string;
  placeId?: string;
  countryCode?: string;
  longitude?: number;
  latitude?: number;
  zipCode?: string;
  countryId?: number;

  constructor(s?: Partial<LocationBaseDTO>) {
    Object.assign(this, s);
  }
}

export class LocationFullDTO extends LocationBaseDTO {
  customerLocations?: CustomerLocationDto[];

  constructor(init?: LocationFullDTO) {
    super(init);
    Object.assign(this, init);
    if (!this.customerLocations) this.customerLocations = [];
  }
}
